import { AuthException } from "./auth.exception";

export class EmailIsSameException extends AuthException {
  constructor() {
    super("errors.auth.emails.same", "New email is the same as current email.");
  }
}
